// extracted by mini-css-extract-plugin
module.exports = {"container":"spinner_container__zL5_Q","absolute":"spinner_absolute__ozOZg","spinner":"spinner_spinner__BzU_1","spin":"spinner_spin__Ci7Bu"};